export enum OrderType {
  RECEIVABLE = 'receivable',
  PAYABLE = 'payable',
}

export const DOCUMENTABLE_TYPE_MAP = {
  [OrderType.RECEIVABLE]: 'receivables',
  [OrderType.PAYABLE]: 'payables',
} as const;

export enum MAPPED_ORDER_STATUS {
  DRAFT = 'draft',
  DISCARDED = 'discarded',
  PREVIEW = 'preview',
  AWAITING_APPROVAL = 'awaiting_approval',
  AWAITING_COMPLIANCE_APPROVAL = 'awaiting_compliance_approval',
  AWAITING_FUNDING_APPROVAL = 'awaiting_funding_approval',
  READY_FOR_PAYMENT = 'ready_for_payment',
  PAYMENT_PROCESSING = 'payment_processing',
  PAID = 'paid',
  INVOICE_OPEN = 'invoice_open',
  INVOICE_OVERDUE = 'invoice_overdue',
  INVOICE_COLLECTION = 'invoice_collection',
  COLLECTION = 'collection',
  CLOSED = 'closed',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
}

export enum ORDER_EVENT {
  CANCEL = 'cancel',
  DISCARD = 'discard',
  SEND_BACK = 'send_back',
  START_PREVIEW = 'start_preview',
  END_PREVIEW = 'end_preview',
  REQUEST_APPROVAL = 'request_approval',
  FUNDING_APPROVE = 'funding_approve',
  COMPLIANCE_APPROVE = 'compliance_approve',
}

export enum ORDER_STATUS {
  DRAFT = 'draft',
  DISCARDED = 'discarded',
  PREVIEW = 'preview',
  AWAITING_APPROVAL = 'awaiting_approval',
  AWAITING_COMPLIANCE_APPROVAL = 'awaiting_compliance_approval',
  AWAITING_FUNDING_APPROVAL = 'awaiting_funding_approval',
  REJECTED = 'rejected',
  OPEN = 'open',
  CLOSED = 'closed',
  CANCELED = 'canceled',
}
